export enum AgioPaymentsPercentages{
    SeventyFive = 75
}